import Cookies from "js-cookie";
import { throttle } from "lodash";

export default class Modal {
  constructor() {
    this.$modal = $("#modal");
    this.cookieKey = "modal";
    this.version = "v1";
    this.expires = parseInt(this.$modal.data("expires") || 5);
  }

  init() {
    if (!this.$modal.length) {
      return;
    }

    if (this.shouldBeDisplayed()) {
      this.watch();
    }
  }

  shouldBeDisplayed() {
    return Cookies.get(this.cookieKey) !== this.version;
  }

  hasScrolledHalfPage() {
    return $(window).scrollTop() + $(window).height() > $(document).height() / 2;
  }

  watch() {
    $(window).on(
      "scroll",
      throttle(() => {
        if (this.shouldBeDisplayed() && this.hasScrolledHalfPage()) {
          this.$modal.modal("show");
        }
      }, 500),
    );

    this.$modal.on("hide.bs.modal", () => {
      Cookies.set(this.cookieKey, this.version, { expires: this.expires });
    });
  }
}
